import {atom} from 'jotai'

export const currentOrganizationState = atom(null)
